// Owner names and alliance tags open their profiles (spec §3.3, P22).
import type { MapSystem } from '@stars-and-ships/api-types';
import { Link } from 'react-router';

const linkClass = 'underline decoration-dotted underline-offset-2 hover:text-info';

export function PlayerLink({
  galaxyId,
  playerId,
  name,
  className = '',
}: {
  galaxyId: string;
  playerId: string;
  name: string;
  className?: string;
}) {
  return (
    <Link to={`/g/${galaxyId}/players/${playerId}`} className={`${linkClass} ${className}`}>
      {name}
    </Link>
  );
}

export function AllianceTagLink({
  galaxyId,
  allianceId,
  tag,
}: {
  galaxyId: string;
  allianceId: string;
  tag: string;
}) {
  return (
    <Link to={`/g/${galaxyId}/alliances/${allianceId}`} className={`text-info ${linkClass}`}>
      [{tag}]
    </Link>
  );
}

/** "You [TAG]" or "Kestrel [RED]" with links, or "Unowned" — the owner of a system. */
export function OwnerLinks({
  galaxyId,
  owner,
  myPlayerId,
}: {
  galaxyId: string;
  owner: MapSystem['owner'];
  myPlayerId: string | undefined;
}) {
  if (!owner) return <>Unowned</>;
  return (
    <>
      {owner.playerId === myPlayerId ? (
        'You'
      ) : (
        <PlayerLink galaxyId={galaxyId} playerId={owner.playerId} name={owner.displayName} />
      )}
      {owner.alliance ? (
        <>
          {' '}
          <AllianceTagLink
            galaxyId={galaxyId}
            allianceId={owner.alliance.id}
            tag={owner.alliance.tag}
          />
        </>
      ) : null}
    </>
  );
}
